export enum UserRoleEnum {
  Invalid = -1,
  All = 0,
  Customer = 1,
  Engineer = 2,
  Manager = 3
}
